// extracted by mini-css-extract-plugin
module.exports = {"dangerous-goods-declaration":"DagerousGoodsDeclaration_dangerous-goods-declaration__mJ_vw","container":"DagerousGoodsDeclaration_container__dX53m"};